import React from "react";
import { Container, Col } from "react-bootstrap";
import {
  textColumns, tcContent, contentTc, cols, tcTitle
} from "./style.mod.scss";
import RichText from "components/rich-text";

const TextColumns = ({ data }) => {

  const { text, bgColor, title } = data;

  return (
    <div className={textColumns} style={{ backgroundColor: bgColor && bgColor.hex }} >
      <Container>
        {title &&
          <Col><h2 className={tcTitle}>{title}</h2></Col>}
        <div className={tcContent}>
          {text?.map((tc, index) => (
            <Col className={cols} key={index}>
              <div className={contentTc}>
                <RichText blocks={tc.blockContent} />
              </div>
            </Col>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default TextColumns;
